import React, { Component, Fragment } from 'react'
import { Link } from 'gatsby'
import logo from '../../images/logo-globe.png'
import CallToAction from './call-to-action.component'
import Modal from './modal.component'

class Navbar extends Component {
  state = {
    scrollY: 0,
    showModal: false,
  }

  updateScrollY = () => {
    this.setState({
      scrollY: window.scrollY,
    })
  }

  toggleModal = () => {
    this.setState((prevState) => ({
      showModal: !prevState.showModal,
    }))
  }

  componentDidMount() {
    document.addEventListener('scroll', this.updateScrollY, false)
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.updateScrollY, false)
  }

  render() {
    const { scrollY, showModal } = this.state

    return (
      <Fragment>
        <nav className={scrollY > 25 ? 'Navbar Navbar--dark' : 'Navbar'}>
          <ul className="Navbar__links">
            <Link to="/" className="Navbar__links--logo">
              <img src={logo} />
            </Link>
            <Link to="/" className="Navbar__links--link">
              Home
            </Link>

            <Link to="/portfolio" className="Navbar__links--link">
              Portfolio
            </Link>
            <Link to="/blog" className="Navbar__links--link">
              Blog
            </Link>
          </ul>
        </nav>

        {showModal && <Modal toggleModal={this.toggleModal} />}

        <CallToAction
          toggleModal={this.toggleModal}
          showClass={scrollY > 25 ? 'visible' : 'hidden'}
        />
      </Fragment>
    )
  }
}

export default Navbar
